
import { Modal, Spin, Row, Col, Radio, message } from "antd";
import ProductDescriptionInput from "components/ProductPage/ProductDescriptionInput/ProductDescriptionInput";
import { useState } from "react";
import { confirmable } from "react-confirm";
import { isEmpty } from "utils/GlobalFunctions";
import "./EntGroupDialog.css"
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";

function EntGroupDialog(props) {
  const { show, proceed, totalBudget } = props;
  const [ entInfo, setEntInfo ] = useState({author_name : '', reason : ''})
  const [entReason, setEntReason] = useState('');

  const validateFields = async () => {
    var errorList = Array();
    errorList = isEmpty(entInfo, "author_name", errorList);
    return errorList.length == 0;
  };
  const onOkAction = async () => {
    if ((await validateFields()) === false) {
      message.error("Please Enter Your Name")
      return
    }
    if (entReason.isEmpty) {
      message.error("Please Enter Ent description")
      return
    }
    entInfo["reason"] = entReason
    setEntInfo({ ...entInfo });
    proceed({
      entInfo : entInfo,
    });
  }
  const onChangeText = (text) => {
    setEntReason(text)
  };
  
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],

      ['clean']                                         // remove formatting button
    ]
  }
  return (
    <Modal
      visible={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="ent-confirm-dlg"
      closable={true}
      maskClosable={false}
      title={`ENT Confirm from you!`}
      onOk={onOkAction}
    >
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div>Your name*</div>
          <ProductDescriptionInput
            placeholder="Enter your name"
            field={"author_name"}
            productInfo={entInfo}
            setProductInfo={setEntInfo}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div>ENT description*</div>
          <ReactQuill theme="snow" value={entReason} onChange={onChangeText}
            modules={modules}
          />
        </Col>
      </Row>
      

    </Modal>
  );
}

export default confirmable(EntGroupDialog);
